/* Product Actions v1.0 - ia- prefix
   Modules: WL (wishlist), AuthModal, Cart, BuyNow, WLPage
   Requires: window.SHOP (injected by theme.liquid)
*/
(function () {
  'use strict';

  if (window.__IA_INITED) return;
  window.__IA_INITED = true;

  /* -------- Shorthand -------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* -------- SHOP config (injected in theme.liquid) -------- */
  var SHOP = window.SHOP || {};
  var loggedIn = !!SHOP.customerLoggedIn;
  var customerId = SHOP.customerId || 'guest';

  /* --------
     MODULE: WL - Wishlist (localStorage)
  -------- */
  var WL = {
    key: 'ia_wl_' + customerId,

    _load: function () {
      try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) { return []; }
    },

    _save: function (items) {
      try { localStorage.setItem(this.key, JSON.stringify(items)); } catch (e) {}
    },

    getAll: function () { return this._load(); },

    has: function (productId) {
      return this._load().some(function (i) { return String(i.id) === String(productId); });
    },

    add: function (data) {
      var items = this._load();
      if (!items.some(function (i) { return String(i.id) === String(data.id); })) {
        items.unshift(data);
        this._save(items);
      }
    },

    remove: function (productId) {
      var items = this._load().filter(function (i) { return String(i.id) !== String(productId); });
      this._save(items);
    },

    toggle: function (data) {
      if (this.has(data.id)) {
        this.remove(data.id);
        return false;
      } else {
        this.add(data);
        return true;
      }
    },

    count: function () { return this._load().length; }
  };

  /* --------
     MODULE: AuthModal
  -------- */
  var AuthModal = {
    el: null,
    _pendingAction: null,  /* 'wishlist' | 'buynow' */
    _pendingData: null,

    init: function () {
      this.el = qs('#ia-auth-modal');
      if (!this.el) return;

      var self = this;

      /* Backdrop close */
      qs('.ia-auth__backdrop', this.el).addEventListener('click', function () {
        self.close();
      });

      /* Close button */
      qs('.ia-auth__close', this.el).addEventListener('click', function () {
        self.close();
      });

      /* Tabs */
      qsa('.ia-auth__tab', this.el).forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.switchTab(tab.getAttribute('data-tab'));
        });
      });

      /* Keyboard close */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.el.hasAttribute('hidden')) {
          self.close();
        }
      });
    },

    switchTab: function (tabName) {
      qsa('.ia-auth__tab', this.el).forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-tab') === tabName);
      });
      qsa('.ia-auth__panel', this.el).forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-panel') === tabName);
      });
    },

    open: function (action, data) {
      this._pendingAction = action;
      this._pendingData = data;
      if (this.el) this.el.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (this.el) this.el.setAttribute('hidden', '');
      document.body.style.overflow = '';
      this._pendingAction = null;
      this._pendingData = null;
    },

    getPending: function () {
      return { action: this._pendingAction, data: this._pendingData };
    }
  };

  /* --------
     MODULE: Cart
  -------- */
  var Cart = {
    /* cb(data, err) - data is the cart response on success and null on failure;
       err carries Shopify's JSON body (e.g. a sold-out message) when there is one. */
    add: function (id, qty, cb) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      })
        .then(function (r) {
          return r.json().then(
            function (d) { return { ok: r.ok, body: d }; },
            function () { return { ok: r.ok, body: null }; }
          );
        })
        .then(function (res) { if (cb) cb(res.ok ? res.body : null, res.ok ? null : res.body); })
        .catch(function (e) { console.error('Cart Add Error:', e); if (cb) cb(null, null); });
    },

    /* The header count and the slide-out drawer belong to layout/theme.liquid.
       Reuse them so a card click looks the same as a product-page click. */
    refresh: function () {
      if (typeof window.fetchCart === 'function') {
        try { return window.fetchCart(); } catch (e) {}
      }
      return null;
    },

    openDrawer: function () {
      if (typeof window.openCart === 'function') {
        try { window.openCart(); } catch (e) {}
      }
    },

    toast: function (msg) {
      if (typeof window.showToast === 'function') {
        try { window.showToast(msg); } catch (e) {}
      }
    },

    errText: function (err) {
      if (err && err.description) return err.description;
      if (err && err.message) return err.message;
      return 'Sorry, we could not add that to your cart.';
    }
  };

  /* --------
     INIT ON PAGE LOAD
  -------- */
  /* One binder throwing must not take the rest of the page's buttons down with it. */
  function safely(label, fn) {
    try { fn(); } catch (e) { console.error('product-actions: ' + label + ' failed', e); }
  }

  function init() {
    safely('AuthModal.init', function () { AuthModal.init(); });
    safely('mergeGuestWishlist', mergeGuestWishlist);
    safely('bindWishButtons', bindWishButtons);
    safely('bindATCButtons', bindATCButtons);
    safely('bindBuyNowButtons', bindBuyNowButtons);
    safely('syncWishlistCount', syncWishlistCount);
    /* If on wishlist page, render items */
    if (qs('#ia-wl-page')) safely('renderWishlistPage', renderWishlistPage);
  }

  /* Saves made before signing in live under ia_wl_guest. Carry them over once so
     the heart does not appear to forget everything the moment someone logs in. */
  function mergeGuestWishlist() {
    if (!loggedIn || WL.key === 'ia_wl_guest') return;
    var guest = [];
    try { guest = JSON.parse(localStorage.getItem('ia_wl_guest') || '[]'); } catch (e) { return; }
    if (!guest.length) return;
    guest.slice().reverse().forEach(function (item) { WL.add(item); });
    try { localStorage.removeItem('ia_wl_guest'); } catch (e) {}
  }

  /* Handlers are attached once per element, so the shopify:section:load rebind
     only picks up freshly injected markup instead of doubling existing buttons. */
  function bindOnce(btn, flag) {
    if (btn.getAttribute(flag) === '1') return false;
    btn.setAttribute(flag, '1');
    return true;
  }

  /* -------- Wishlist toggle -------- */
  function bindWishButtons() {
    qsa('[data-wish-btn], [data-wishlist-btn]').forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      var ptitle = btn.getAttribute('data-product-title') || '';
      var pimg = btn.getAttribute('data-product-image') || '';
      var phandle = btn.getAttribute('data-product-handle') || '';
      var pprice = btn.getAttribute('data-product-price') || '';

      /* Sync initial state */
      if (WL.has(pid)) {
        btn.classList.add('ia-wish--active');
        var svg = qs('svg', btn);
        if (svg && svg.querySelector('path')) svg.querySelector('path').setAttribute('fill', 'currentColor');
      }

      if (!bindOnce(btn, 'data-ia-wish-bound')) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        /* The wishlist is localStorage-backed, so guests can use it too. */
        var added = WL.toggle({ id: pid, title: ptitle, image: pimg, handle: phandle, price: pprice });
        syncWishlistCount();
        btn.setAttribute('aria-pressed', added ? 'true' : 'false');
        Cart.toast(added ? 'Saved to wishlist' : 'Removed from wishlist');

        btn.classList.toggle('ia-wish--active', added);
        btn.classList.add('ia-wish--pop');
        setTimeout(function () { btn.classList.remove('ia-wish--pop'); }, 400);

        var svg = qs('svg', btn);
        if (svg && svg.querySelector('path')) {
          svg.querySelector('path').setAttribute('fill', added ? 'currentColor' : 'none');
        }
      });
    });
  }

  function syncWishlistCount() {
    var count = WL.count();
    var badge = qs('.hdr-wish-count');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('is-visible', count > 0);
  }

  /* -------- Add to Cart buttons -------- */
  function bindATCButtons() {
    qsa('[data-atc-btn]').forEach(function (btn) {
      if (!bindOnce(btn, 'data-ia-atc-bound')) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) return;

        btn.classList.add('ia-btn--loading');
        btn.disabled = true;

        Cart.add(vid, 1, function (data, err) {
          btn.classList.remove('ia-btn--loading');
          btn.disabled = false;

          if (!data) {
            Cart.toast(Cart.errText(err));
            return;
          }

          window.dispatchEvent(new CustomEvent('ia:cart-added', { detail: data }));

          /* Refresh the header count and drawer contents first, then reveal the
             drawer, so a stale cart never slides into view. */
          var pending = Cart.refresh();
          if (pending && typeof pending.then === 'function') {
            pending.then(function () { Cart.openDrawer(); }, function () { Cart.openDrawer(); });
          } else {
            Cart.openDrawer();
          }
          Cart.toast('\u2714 Added to cart!');
        });
      });
    });
  }

  /* -------- Buy Now buttons -------- */
  function bindBuyNowButtons() {
    /* The product card renders data-buy-now-btn; data-buy-btn is kept so any
       hand-written markup elsewhere in the theme keeps working. */
    qsa('[data-buy-btn], [data-buy-now-btn]').forEach(function (btn) {
      if (!bindOnce(btn, 'data-ia-buy-bound')) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) return;

        /* No sign-in wall: Shopify checkout offers login or guest checkout itself,
           and stopping here stranded the shopper with nothing to continue to. */
        btn.disabled = true;
        Cart.add(vid, 1, function (data, err) {
          if (data) {
            window.location.href = '/checkout';
            return;
          }
          btn.disabled = false;
          Cart.toast(Cart.errText(err));
        });
      });
    });
  }

  /* --------
     WISHLIST PAGE
  -------- */
  function renderWishlistPage() {
    var container = qs('#ia-wl-page');
    if (!container) return;

    if (!loggedIn) {
      container.innerHTML = '<div class="ia-wl-login"><p class="ia-wl-login__title">Sign in to view your wishlist</p><p class="ia-wl-login__text">Save your favorites and access them anytime.</p><div class="ia-wl-login__actions"><a href="/account/login" class="ia-wl-login__btn ia-wl-login__btn--primary">Sign In</a><a href="/" class="ia-wl-login__btn ia-wl-login__btn--outline">Continue Shopping</a></div></div>';
      return;
    }

    var items = WL.getAll();
    var countEl = qs('.ia-wl-page__count');
    var gridEl = qs('.ia-wl-grid', container);
    var emptyEl = qs('.ia-wl-empty', container);

    if (items.length === 0) {
      if (gridEl) gridEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'flex';
      if (countEl) countEl.textContent = '(' + items.length + ' items)';
      return;
    }

    if (gridEl) gridEl.style.display = 'grid';
    if (emptyEl) emptyEl.style.display = 'none';
    if (countEl) countEl.textContent = '(' + items.length + ' item' + (items.length !== 1 ? 's' : '') + ')';

    if (gridEl) {
      gridEl.innerHTML = '';
      items.forEach(function (item) {
        var card = document.createElement('div');
        card.className = 'pcard';
        card.innerHTML = ''
        + '<div class="pcard__media">'
        + '  <button class="ia-wl-remove" data-rmv-btn="' + item.id + '">&times;</button>'
        + '  <a href="/products/' + item.handle + '"><img class="pcard__img" src="' + item.image + '"></a>'
        + '</div>'
        + '<div class="pcard__body"><div class="pcard__title"><a href="/products/' + item.handle + '">' + item.title + '</a></div><div class="pcard__price-row"><div class="pcard__price">' + item.price + '</div></div></div>';
        gridEl.appendChild(card);
      });
      bindRemoveButtons();
    }
  }

  function bindRemoveButtons() {
    qsa('[data-rmv-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pid = btn.getAttribute('data-rmv-btn');
        WL.remove(pid);
        renderWishlistPage();
        syncWishlistCount();
        syncAllWishButtons();
      });
    });
  }

  function syncAllWishButtons() {
    qsa('[data-wish-btn], [data-wishlist-btn]').forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      var hasIt = WL.has(pid);
      btn.classList.toggle('ia-wish--active', hasIt);
      var svg = qs('svg', btn);
      if (svg && svg.querySelector('path')) {
        svg.querySelector('path').setAttribute('fill', hasIt ? 'currentColor' : 'none');
      }
    });
  }

  /* Init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Section reloads */
  document.addEventListener('shopify:section:load', function () {
    bindWishButtons();
    bindATCButtons();
    bindBuyNowButtons();
  });
}());